import { Card } from "react-bootstrap";
import InfoTable from "../InfoTable";
import moment from "moment";
import { getDateFormat } from "../../views/Valid";

export default function CardPensiun({ dataDocu = {} }) {
  return (
    <>
      <Card
        className="text-start mx-auto glass-effect"
        style={{ maxWidth: "40rem", fontSize: "0.85rem" }}
      >
        <Card.Header>
          <b>Informasi Dokumen - Layanan Pemberhentian</b>
        </Card.Header>
        <Card.Body style={{ borderCollapse: "collapse" }}>
          <InfoTable
            listData={[
              ["NIP", ":", dataDocu?.nip],
              ["NAMA", ":", dataDocu?.nama],
              ["JENIS GOLONGAN", ":", dataDocu?.sub_layanan_pensiun],
              ["JENIS PEMBERHENTIAN", ":", dataDocu?.detail_layanan_pensiun],
              ["JABATAN", ":", dataDocu?.jabatan || dataDocu?.jenis_jabatan],
              [
                "TMT PENSIUN",
                ":",
                moment(dataDocu?.tmt_pensiun, "YYYY-MM-DD").format(
                  "DD-MM-YYYY"
                ),
              ],
              ["GOLONGAN", ":", dataDocu?.golongan],
              [`NO ${dataDocu?.jenis_dok || "DOKUMEN"}`, ":", dataDocu?.nomor],
              [
                `TGL ${dataDocu?.jenis_dok || "DOKUMEN"}`,
                ":",
                getDateFormat(dataDocu?.tanggal),
              ],
              ["INSTANSI", ":", dataDocu?.instansi],
              [
                "STATUS DOKUMEN",
                ":",
                dataDocu?.status || dataDocu?.path_ttd || dataDocu?.pathTtd
                  ? "Valid"
                  : "Tidak Valid",
              ],
            ]}
            style={{
              borderBottom: "1px solid #CCCCCC50",
            }}
          />
        </Card.Body>
      </Card>
      <Card
        className="text-start mx-auto glass-effect mt-4"
        style={{ maxWidth: "40rem", fontSize: "0.85rem" }}
      >
        <Card.Header>
          <b>Informasi Penanda Tangan</b>
        </Card.Header>
        <Card.Body style={{ borderCollapse: "collapse" }}>
          <InfoTable
            listData={[
              ["NIP", ":", dataDocu?.nip_penandatangan],
              ["NAMA", ":", dataDocu?.penandatangan],
              ["JABATAN", ":", dataDocu?.jabatan_penandatangan],
              ["INSTANSI", ":", dataDocu?.instansi_penandatangan],
              ["TGL PENANDATANGAN", ":", getDateFormat(dataDocu?.tanggal)],
            ]}
            style={{
              borderBottom: "1px solid #CCCCCC50",
            }}
          />
        </Card.Body>
      </Card>
    </>
  );
}
